import { isDataSharingOptedOut } from 'chairisher/context/account';

/**
 * @type {Array.<Object>}
 */
let rdtQueue = [];

/**
 * Id of the interval being used to flush the reddit event queue
 *
 * @type {number|null}
 */
let rdtQueueIntervalId = null;

/**
 * Sends enqueued reddit events that occurred before reddit was loaded
 */
function purgeRdtQueue() {
    for (let i = 0; i < rdtQueue.length; i += 1) {
        window.rdt.apply(window.rdt, rdtQueue[i]);
    }

    rdtQueue = [];
}

/**
 * Sends Reddit a conversion event
 *
 * @param {Array} eventData Event data to pass to Reddit
 */
export function logRedditEvent(eventData) {
    if (!isDataSharingOptedOut()) {
        if (window.rdt) {
            window.rdt.apply(window.rdt, eventData);
        } else {
            rdtQueue.push(eventData);

            if (!rdtQueueIntervalId) {
                rdtQueueIntervalId = window.setInterval(() => {
                    if (window.rdt) {
                        window.clearInterval(rdtQueueIntervalId);
                        rdtQueueIntervalId = null;
                        purgeRdtQueue();
                    }
                }, 1000);
            }
        }
    }
}
